var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { css } from '@creditas-ui/system';
export var disabledMode = _ref => {
  var {
    theme: {
      tag
    }
  } = _ref;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n\n  cursor: not-allowed;\n\n  svg {\n    opacity: 1;\n\n    g {\n      circle,\n      polyline,\n      line,\n      path {\n        stroke: ", ";\n      }\n\n      path:first-of-type {\n        stroke: none;\n      }\n    }\n  }\n"])), tag('disabled.icon.color'), tag('disabled.icon.color'));
};
//# sourceMappingURL=disabled.js.map